<template>
  <div class="signin-wrapper">
    <div class="signin-form">
      <form>
        <input
          type="text"
          v-model="username"
          class="form-control"
          placeholder="Usuario"
        />
        <input
          type="password"
          v-model="password"
          class="form-control"
          placeholder="Contraseña"
        />
        <button
          type="button"
          @click.stop="onAttemptSignin()"
          :disabled="isSigninButtonDisabled"
          class="btn"
        >
          <span v-if="!loading">Iniciar sesión</span>
          <i v-else class="fa fa-spin fa-spinner"></i>
        </button>
      </form>
      <vue-toastr ref="toastr"></vue-toastr>
    </div>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";

export default {
  components: {
    VueToastr,
  },
  data() {
    return {
      username: "",
      password: "",
      loading: false,
    };
  },
  computed: {
    isSigninButtonDisabled() {
      return this.username == "" || this.password == "";
    },
  },
  methods: {
    async onAttemptSignin() {
      this.loading = true;

      let errorMessage = await this.$store.dispatch("attemptSigninIn", {
        username: this.username,
        password: this.password,
      });

      if (!errorMessage) {
        // save userName in localStorage
        localStorage.setItem("userNameNew", this.username);

        this.$router.push("/");
      } else {
        this.$refs.toastr.e({
          msg: errorMessage,
          preventDuplicates: true,
          type: "error",
        });
      }

      this.loading = false;
    },
  },
};
</script>

<style lang="scss">
.signin-wrapper {
  width: 100%;
  height: 100%;

  .signin-form {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .logo {
      width: 90%;
      margin: 0 auto;
      max-width: 420px;
      margin-bottom: 50px;
    }

    form {
      width: 350px;
      text-align: center;

      input {
        margin-bottom: 10px;
      }

      button {
        margin-top: 5px;
        background-color: #579adc;
        color: white;
        width: 125px;

        &[disabled] {
          background-color: #b9b9b9;
          opacity: 1;
        }
      }
    }
  }
}
</style>
